export const MODULE_CONFIG = {
    title: 'Sign In',
    platformSessionsKey: 'pac-platform-sessions',
    rememberedAccountKey: 'pac-handoff-account',
    cognitoIdpEndpoint: 'https://cognito-idp.us-west-2.amazonaws.com/',
    platformSessionChallenge: 'PLATFORM_SESSION',
};
